module.exports = __webpack_public_path__ + "img/full7-min.f8b58559.png";